import { Form } from "antd";
import { useState } from "react";
import GraphqlService from "../../services/graphql/GraphqlService";
import { Query } from "../../services/graphql/query";
import { IFile } from "../../services/File";
import { IImagenInput } from "../../components/BusquedaImagenes/BusquedaImagenes";

export interface IFormValues {
  patente: string;
}

const useBusquedaImagen = () => {
  const { customRequest } = GraphqlService();
  const [clearButton, setClearButton] = useState<boolean>(false);
  const [imagenes, setImagenes] = useState<IFile[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [termSearched, setTermSearched] = useState<string>("");
  const [formValuesOnLoad, setFormValuesOnLoad] = useState<any>();
  const [form] = Form.useForm();

  const cleanSearch = (): void => {
    form.setFieldsValue({
      patente: "",
    });
    form.resetFields();
    setImagenes([]);
    setClearButton(false);
  };

  const getImagenes = async (values: IImagenInput) => {
    const { patente } = values;
    setLoading(true);
    setImagenes([]);
    setTermSearched(patente);

    await customRequest({
      query: Query.filesByLicensePlate,
      variables: { licensePlate: patente.toUpperCase() },
    })
      .then((data: IFile[]) => {
        setImagenes(data);
        setClearButton(true);
      })
      .catch(() => {
        //Intentional
      })
      .finally(() => {
        setLoading(false);
      });
      setClearButton(true);
  };

  return {
    getImagenes,
    setImagenes,
    imagenes,
    clearButton,
    loading,
    cleanSearch,
    formValuesOnLoad,
    setFormValuesOnLoad,
    termSearched,
  };
};

export default useBusquedaImagen;
